import React from 'react';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { SvgIconButtonShim } from '@coherence-design-system/icon';
import { IconButton } from '@fluentui/react';
import { DirectionalHint } from "office-ui-fabric-react";

export interface InfoIconProps {
  iconName: string;
  tooltipText: string | React.ReactNode;
  directionalHint?: DirectionalHint;
}

export const InfoIcon: React.FunctionComponent<InfoIconProps> = (props) => {
  return (
    <TooltipHost content={props.tooltipText} directionalHint={props.directionalHint}>
      <SvgIconButtonShim
        svgIconsEnabled={true}
        buttonAs={IconButton}
        aria-label={props.iconName}
        iconProps={{ iconName: props.iconName }}
        text={props.iconName}
        className='dropdownInfoIcon mb-3'
      />
    </TooltipHost>
  );
};
